import * as React from 'react'

export interface Props {
  url: string
  async?: boolean
  onLoad?: () => void
  onError?: (e: string | Event) => void
}

const Script: React.FC<Props> = ({
  url,
  async = false,
  onLoad = () => {},
  onError = () => {}
}) => {
  const [el, setEl] = React.useState<null | HTMLScriptElement>(null)

  React.useEffect(() => {
    if (el) {
      return unload
    }

    const script = document.createElement('script')

    script.src = url
    script.async = async
    script.onload = () => onLoad()
    script.onerror = e => onError(e)

    document.body.appendChild(script)
    setEl(script)

    return unload

    function unload() {
      if (!el) {
        return
      }
      document.body.removeChild(el)
    }
  }, [el])

  return null
}

export default Script
